import { render, staticRenderFns } from "./ForTeachers.vue?vue&type=template&id=a9ec0a8a&lang=pug&"
import script from "./ForTeachers.vue?vue&type=script&lang=js&"
export * from "./ForTeachers.vue?vue&type=script&lang=js&"
import style0 from "./ForTeachers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports